var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"autocomplete-viewer"},[_c('gmap-autocomplete',{attrs:{"placeholder":"Búsqueda de Lugares"},on:{"place_changed":_vm.setPlace}}),_c('object',{staticClass:"autocomplete-viewer__icon",attrs:{"type":"image/svg+xml","data":"img/icons/icon-magnifier.svg"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }